module.exports = __webpack_public_path__ + "img/20190828172059.6e9935aa.png";